import { render } from "./HomeData.vue?vue&type=template&id=10c3e355"
import script from "./HomeData.vue?vue&type=script&lang=js"
export * from "./HomeData.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__